<app-pageheader Title="Car Counters">
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="true" ApiUrl="infrastructure/carcounterconfigurations/searches"
  [AllowEdit]="true" EditUrl="/hardware/devices/carcounters/:id" [StructureViewerLayers]="StructureViewerLayers" StructureViewerForType="CarCounterConfiguration">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>